var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10595_2993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 3.51563C16.7344 5.06894 15.4752 6.32812 13.9219 6.32812C12.3686 6.32812 11.1094 5.06894 11.1094 3.51563C11.1094 1.96233 12.3686 0.703142 13.9219 0.703142C15.4752 0.703142 16.7344 1.96233 16.7344 3.51563Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89061 9.00001C6.89061 10.5533 5.63142 11.8125 4.07812 11.8125C2.52481 11.8125 1.26562 10.5533 1.26562 9.00001C1.26562 7.4467 2.52481 6.18752 4.07812 6.18752C5.63142 6.18752 6.89061 7.4467 6.89061 9.00001Z",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7344 14.4844C16.7344 16.0377 15.4752 17.2969 13.9219 17.2969C12.3686 17.2969 11.1094 16.0377 11.1094 14.4844C11.1094 12.9311 12.3686 11.6719 13.9219 11.6719C15.4752 11.6719 16.7344 12.9311 16.7344 14.4844Z",
    stroke: "#4CBC18",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.03801 6.16635L6.51953 7.60547",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.51953 10.3968L9.03801 11.8359",
    stroke: "#A3A3A3",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.07812 9.20312C4.19032 9.20312 4.28125 9.11219 4.28125 9C4.28125 8.88781 4.19032 8.79688 4.07812 8.79688C3.96593 8.79688 3.875 8.88781 3.875 9C3.875 9.11219 3.96593 9.20312 4.07812 9.20312Z",
    fill: "white",
    stroke: "#A3A3A3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10595_2993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.91947e3b85f9d03d74cfa3c91f5c80d3.svg";
export { ForwardRef as ReactComponent };